import { Button, Column, Container, TextInput, Title } from 'components';
import { MIN_TEXT_INPUT_LENGTH } from 'global-constants';
import { UpdateExpertArea } from 'models/expert-certificates';
import React, { FC } from 'react';
import { FieldValues, useForm } from 'react-hook-form-new';
import { useTranslation } from 'react-i18next';

interface Props {
    data?: UpdateExpertArea;
    add: (val: UpdateExpertArea) => void;
    update: (val: UpdateExpertArea) => void;
}

export const EditArea: FC<Props> = ({ data, add, update }) => {
    const [t] = useTranslation(['validation']);
    const methods = useForm<UpdateExpertArea>({ defaultValues: data });
    const {
        register,
        formState: { isSubmitting, errors },
        handleSubmit,
    } = methods;

    const submit = (fields: FieldValues) => {
        data?.id ? update(fields as UpdateExpertArea) : add(fields as UpdateExpertArea);
    };

    return (
        <Container>
            <Column columnSize="50">
                <Title titleText={data?.id ? 'Редактирование' : 'Добавление'} />
            </Column>

            <Column columnSize="100">
                <form onSubmit={handleSubmit(submit)} autoComplete="off">
                    <input type="hidden" {...register('id')} defaultValue={data?.id} />
                    <Column columnSize="100">
                        <TextInput
                            label="Имя"
                            id="nameId"
                            reg={register('name', {
                                required: {
                                    value: true,
                                    message: t('validation:required-field'),
                                },
                                minLength: {
                                    value: MIN_TEXT_INPUT_LENGTH,
                                    message: t('validation:min-length', {
                                        minLength: MIN_TEXT_INPUT_LENGTH,
                                    }),
                                },
                                maxLength: {
                                    value: 100,
                                    message: t('validation:max-length', {
                                        maxLength: 100,
                                    }),
                                },
                            })}
                            errorMessage={errors.name?.message as string}
                        />
                    </Column>
                    <Column columnSize="100">
                        <div className="info-buttons d-flex">
                            <Button type="submit" buttonClass="primary" isDisabled={isSubmitting}>
                                Сохранить
                            </Button>
                        </div>
                    </Column>
                </form>
            </Column>
        </Container>
    );
};
